import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';
import * as fromRoot from '../../../vas/store/bootstrap';
import { VasState } from '../../../vas/store/store-type';

export class ObjectsStoreFacade  {

    constructor(
        protected appFacade: VasAppFacade,
        private store: Store<fromRoot.State>
    ) {

    }

    dispatch(action): void {
        this.store.dispatch(action);
    }

    select<T extends VasState, R>(mapFn: (state: T) => R): Observable<R> {
        return this.store.select(mapFn);
    }
}



// WEBPACK FOOTER //
// ./src/core/store/facade/objects-store-facade.ts